module.exports = __webpack_public_path__ + "static/media/14.12161e04.JPG";